export default __webpack_public_path__ + "static/media/ketoenergybar@3x.4d67bfd6.jpg";